
import React from "react";

//========================================================
// OmniScan Colours
//========================================================

const OMNISCAN_BLUE = "#20AFE8";
const OMNISCAN_BLUE_RGB = "32, 175, 232";
const OMNISCAN_BLUE_SOFT = "#8DC8F0";

const PASS_GREEN = "#2ecc71";

//========================================================
// Shared Glass Styling
//========================================================

const GLASS_BACKGROUND =
    "linear-gradient(145deg, rgba(255,255,255,0.10) 0%, rgba(255,255,255,0.045) 100%)";

const GLASS_BORDER =
    "1px solid rgba(255,255,255,0.13)";

const GLASS_SHADOW =
    "0 8px 24px rgba(0,0,0,0.12), inset 0 1px 0 rgba(255,255,255,0.05)";

const DIVIDER_BACKGROUND =
    `linear-gradient(90deg, rgba(${OMNISCAN_BLUE_RGB},0.42), rgba(255,255,255,0.04))`;

//========================================================
// Asset Insights Drawer
//========================================================

export default function AssetInsightsDrawer()
{
    return (
        <div
            className="omniscan-glass-scroll"
            style={{
                height: "100%",
                padding: "28px",
                boxSizing: "border-box",

                display: "flex",
                flexDirection: "column",

                overflowY: "auto",

                scrollbarWidth: "thin",
                scrollbarColor:
                    "rgba(141,200,240,0.30) transparent",

                color: "#ffffff",

                background:
                    "linear-gradient(180deg, rgba(18,34,49,0.10) 0%, rgba(9,20,33,0.18) 100%)"
            }}
        >

            {/* AI VERIFIED */}

            <div
                style={{
                    alignSelf: "flex-start",

                    padding: "8px 18px",

                    borderRadius: "5px",

                    background:
                        `rgba(${OMNISCAN_BLUE_RGB},0.12)`,

                    border:
                        `1px solid rgba(${OMNISCAN_BLUE_RGB},0.35)`,

                    color: OMNISCAN_BLUE_SOFT,

                    fontSize: "13px",
                    fontWeight: 700,

                    boxShadow:
                        "0 4px 14px rgba(0,0,0,0.10)"
                }}
            >
                ● AI VERIFIED
            </div>


            {/* TITLE */}

            <div
                style={{
                    marginTop: "20px",

                    fontSize: "30px",
                    fontWeight: 700,

                    color: "#ffffff",

                    letterSpacing: "-0.5px",
                    lineHeight: 1.2,

                    textShadow:
                        "0 2px 8px rgba(0,0,0,0.15)"
                }}
            >
                AI Assessment
            </div>

            <div
                style={{
                    marginTop: "8px",

                    color: "#B9D1E2",
                    fontSize: "14px"
                }}
            >
                Generated 14 July 2026
            </div>


            {/* CONFIDENCE SCORE */}

            <div
                style={{
                    marginTop: "34px",

                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}
            >

                <div>

                    <div
                        style={{
                            color: "#B9D1E2",
                            fontSize: "13px"
                        }}
                    >
                        Confidence
                    </div>

                    <div
                        style={{
                            marginTop: "6px",

                            color: "#ffffff",

                            fontSize: "38px",
                            fontWeight: 700,

                            letterSpacing: "-1px"
                        }}
                    >
                        98%
                    </div>

                </div>


                {/* AI INDICATOR */}

                <div
                    style={{
                        width: "92px",
                        height: "92px",

                        flexShrink: 0,

                        borderRadius: "50%",

                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",

                        background:
                            `linear-gradient(160deg, ${OMNISCAN_BLUE} 0%, #137DAD 100%)`,

                        border:
                            "1px solid rgba(255,255,255,0.22)",

                        color: "#ffffff",

                        fontWeight: 700,
                        fontSize: "22px",

                        boxShadow:
                            `0 8px 24px rgba(${OMNISCAN_BLUE_RGB},0.25), inset 0 1px 0 rgba(255,255,255,0.18)`
                    }}
                >
                    AI
                </div>

            </div>


            {/* DIVIDER */}

            <div
                style={{
                    marginTop: "28px",

                    height: "1px",
                    flexShrink: 0,

                    background: DIVIDER_BACKGROUND
                }}
            />


            {/* FINDINGS */}

            <div
                style={{
                    marginTop: "28px",

                    display: "grid",

                    gridTemplateColumns:
                        "repeat(2, minmax(0, 1fr))",

                    gap: "14px"
                }}
            >

                <FindingCard
                    title="Identification"
                    value="Confirmed"
                    colour={PASS_GREEN}
                />

                <FindingCard
                    title="Condition"
                    value="Good"
                    colour={PASS_GREEN}
                />

                <FindingCard
                    title="Compliance"
                    value="No Issues"
                    colour={PASS_GREEN}
                />

                <FindingCard
                    title="Risk"
                    value="Low"
                    colour={OMNISCAN_BLUE}
                />

            </div>


            {/* DIVIDER */}

            <div
                style={{
                    marginTop: "28px",

                    height: "1px",
                    flexShrink: 0,

                    background: DIVIDER_BACKGROUND
                }}
            />


            {/* ACTIONS */}

            <div
                style={{
                    marginTop: "22px",

                    display: "flex",
                    flexDirection: "column",

                    gap: "12px",

                    paddingBottom: "16px"
                }}
            >

                <ActionButton
                    title="AI Observation"
                />

                <ActionButton
                    title="Recommendations"
                />

                <ActionButton
                    title="Related Insights"
                />

            </div>

        </div>
    );
}


//========================================================
// Finding Card
//========================================================

function FindingCard({
    title,
    value,
    colour
})
{
    return (
        <div
            style={{
                padding: "18px",

                borderRadius: "8px",

                background: GLASS_BACKGROUND,

                border: GLASS_BORDER,

                boxShadow: GLASS_SHADOW,

                backdropFilter: "blur(12px)",
                WebkitBackdropFilter: "blur(12px)"
            }}
        >

            <div
                style={{
                    color: "#F0F6FA",

                    fontSize: "15px",
                    fontWeight: 600
                }}
            >
                {title}
            </div>

            <div
                style={{
                    marginTop: "12px",

                    color: colour,

                    fontWeight: 700,
                    fontSize: "13px"
                }}
            >
                ● {value}
            </div>

        </div>
    );
}


//========================================================
// Action Button
//========================================================

function ActionButton({
    title
})
{
    return (
        <div
            style={{
                minHeight: "56px",

                borderRadius: "7px",

                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",

                padding: "0 20px",

                background: GLASS_BACKGROUND,

                border: GLASS_BORDER,

                boxShadow: GLASS_SHADOW,

                backdropFilter: "blur(12px)",
                WebkitBackdropFilter: "blur(12px)",

                color: "#F0F6FA",

                cursor: "pointer",

                fontSize: "14px",
                fontWeight: 600,

                transition:
                    "background 0.2s ease, border-color 0.2s ease"
            }}
        >

            <span>
                {title}
            </span>

            <div
                style={{
                    color: OMNISCAN_BLUE_SOFT,

                    fontSize: "22px",
                    fontWeight: 600,

                    marginLeft: "12px",

                    textShadow:
                        `0 0 10px rgba(${OMNISCAN_BLUE_RGB},0.20)`
                }}
            >
                ›
            </div>

        </div>
    );
}
